// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const StepSection: MarkdocTagRegistration = {
  tag: 'step-section',
  component: 'StepSection',
  attributes: {
    number: {
      type: Number,
      required: false,
    },
    title: {
      type: String,
      required: false,
      localizable: true,
    },
    toggle: {
      type: Boolean,
      required: false,
    },
  },
  validate(node) {
    const attributes = node.attributes || {};
    if (
      attributes.toggle === undefined &&
      attributes.title === undefined &&
      attributes.number === undefined
    ) {
      return [
        {
          id: 'step-section-invalid-attributes',
          level: 'critical',
          message:
            'step-section must have a title and number defined, or be a toggle section',
        },
      ];
    }
    return [];
  },
};
